var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      class: _vm.textClasses,
      attrs: { tabindex: "0", href: "#" },
      on: {
        mouseover: function($event) {
          _vm.active = true
        },
        mouseout: function($event) {
          _vm.active = false
        }
      }
    },
    [
      _vm._t(
        "suggestion",
        [_c("span", { domProps: { innerHTML: _vm._s(_vm.htmlText) } })],
        null,
        { data: _vm.data, htmlText: _vm.htmlText }
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0fab5a10", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fab5a10","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VueBootstrapTypeaheadListItem.vue
// module id = null
// module chunks = 